var React = require('react');

function BlackCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-56.696 -94.494)","strokeWidth":".26458"},React.createElement("circle",{"cx":"86.462","cy":"124.26","r":"29.766"})));
}

BlackCircle.defaultProps = {"width":"59.531","version":"1.1","viewBox":"0 0 59.531 59.531"};

module.exports = BlackCircle;

BlackCircle.default = BlackCircle;
